import { LenderRule, lenderFor, senderEmail } from '../lenders';

export interface SenderOption {
  /** The stored sender, lower-cased: the exact partition the embeddings list expects. */
  value: string;
  label: string;
}

/** Senders from the queue, approved examples and configured lender addresses, labelled "Lender · address". */
export const buildSenderOptions = (senders: Array<string | null | undefined>, rules: LenderRule[]): SenderOption[] => {
  const options = new Map<string, SenderOption>();
  senders.forEach((raw) => {
    const value = (raw || '').trim().toLowerCase();
    if (!value.includes('@') || options.has(value)) return;
    options.set(value, { value, label: `${lenderFor(value, rules) ?? 'No lender set'} · ${senderEmail(value)}` });
  });
  rules.filter((rule) => rule.kind === 'exact').forEach((rule) => {
    if (!options.has(rule.match)) options.set(rule.match, { value: rule.match, label: `${rule.label} · ${rule.match}` });
  });
  return Array.from(options.values()).sort((a, b) => a.label.localeCompare(b.label));
};
